<script>
  /**
   * The visibility control: a labeled toolbar button whose icon shows the
   * current state, opening the role-appropriate options. `variant='inline'`
   * renders the options directly (used inside compact tool menus).
   */
  import { page } from '$app/state';
  import Popover from '#lib/Popover.svelte';
  import ButtonLabel from '#lib/ButtonLabel.svelte';
  import t from '#lib/i18n.svelte.js';
  import { get_visibility_icon } from '#lib/util.js';

  let { entry, variant = 'button' } = $props();

  // Same role rules as everywhere else: members can only choose member/private.
  let options_list = $derived([
    page.data.current_user?.role === 'admin' && { value: 'public', title: t('public'), description: t('everyone_on_the_internet') },
    { value: 'member', title: t('member_plural'), description: t('only_members') },
    page.data.current_user?.role === 'admin' && { value: 'internal', title: t('internal'), description: t('admins_only_visibility') },
    { value: 'private', title: t('private'), description: t('just_you') },
  ].filter(Boolean));

  let anchor_ref = $state();
  let popover_ref = $state();

  function select(value) {
    entry.visibility = value;
    popover_ref?.hidePopover?.();
  }
</script>

{#snippet options()}
  {#each options_list as option (option.value)}
    <button onclick={() => select(option.value)} title={option.description}>
      <ButtonLabel
        variant='brand ghostly text-compact'
        align='start-stretch'
        start_icon={get_visibility_icon(option.value)}
        end_icon={entry.visibility === option.value ? 'check' : ' '}
      >
        {option.title}
      </ButtonLabel>
    </button>
  {/each}
{/snippet}

{#if variant === 'inline'}
  <div class='flex-column'>
    {@render options()}
  </div>
{:else}
  <button
    bind:this={anchor_ref}
    popovertarget='visibility_tool_{entry.entry_id ?? 'new'}'
    title={t('visibility')}
  >
    <ButtonLabel variant='brand ghostly text-compact' start_icon={get_visibility_icon(entry.visibility)}>
      {t('visibility')}
    </ButtonLabel>
  </button>

  <Popover
    anchor={anchor_ref}
    bind:ref={popover_ref}
    id='visibility_tool_{entry.entry_id ?? 'new'}'
    placement='bottom-start'
  >
    <div class='flex-column py p-2 px p-2'>
      {@render options()}
    </div>
  </Popover>
{/if}
